import { render } from "./AddIdeaSimple.vue?vue&type=template&id=8cd7857e&scoped=true"
import script from "./AddIdeaSimple.vue?vue&type=script&lang=js"
export * from "./AddIdeaSimple.vue?vue&type=script&lang=js"

import "./AddIdeaSimple.vue?vue&type=style&index=0&id=8cd7857e&scoped=true&lang=css"
import "./AddIdeaSimple.vue?vue&type=style&index=1&id=8cd7857e&lang=css"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cd7857e"]])

export default __exports__